import React from 'react';
import {
	Table,
	message,
	Popconfirm,
	Button,
	Icon,
	Input,
	Select,
	Form,
	Modal,
	Row,
	Col,
	Tooltip,
	Tag,
	Statistic,
	Pagination,
	Card,
	Divider,
	Avatar,
} from 'antd';
import { CheckOutlined } from '@ant-design/icons';
import { orderlistAc as AC } from '../../../redux/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import ModalRender from './ModalRender';
import ModalUpload from './ModalUpload';
import { server } from '../../../config/serverConfig';
import SearchRender from './SearchRender';
import OrderDetail from '../../../components/orderDetail';
import { download2 } from "../../../utils";
import OrderRepayDetail from "../../../components/orderRepayDetail";

function RenderBase({ appRd, store, del, set, cancelOrder, get, getxls, getxls_all, create, update, updateremove }) {


	//导入本组件所需参数变量
	const { data, dataLoading, orderRepayDetailVisible, dataFetchProps, searchProps, selectedRows, selectedRowKeys, modalVisible, modalType, uploadModalVisible, selectedRow, selectedRowIndex, orderDetailVisible, clickRow, pagination } = store;
	const { loginData, screenType, loginUserRoleAuth } = appRd;

	//dataFetchProps		
	if (dataLoading) {
		//全局尽量统一通过修改dataLoading来刷新数据，以减少数据不准一。
		get({ ...dataFetchProps, ...searchProps });

	}   // {onlyDeletedRows: true,user_name: 'a', roleid: 'admin', order:[['id']], offset: 2, limit: 2}		

	//刷新按钮强制刷新，需要提示
	const refreshData = async () => {
		let msg = await get({ ...dataFetchProps, ...searchProps });
		message.info(msg);
	}


	//整理表头数据
	var filtersbizperson = [], bizpersonArr = [];

	data.map(value => {

		//添加搜索字段

		if (bizpersonArr.indexOf(value.bizperson) === -1) {
			bizpersonArr.push(value.bizperson);
			filtersbizperson.push({ text: value.bizperson, value: value.bizperson });
		}

		return null;

	})

	//定义表头
	const columns = [{
		title: 'id',
		dataIndex: 'id',
		key: 'id',
		className: 'align_center',
		width: 80,
		height: 40, // 设置列高度
	}, {
		title: '客户名称',
		dataIndex: 'm_orderclient',
		key: 'm_orderclient',
		render: (text, record) => text.length > 0 && text[0].cust_name ? <span>{text[0].cust_name}</span> : <span>{record.client_id}</span>,
		width: 160
	},{
		title: '产品模式',
		dataIndex: 'guarantee_type',
		key: 'guarantee_type',
		width: 120,
		render: (text, record) => (
			<div>
				{text !== undefined && text !== null ? (
					<span>
          <Avatar size="small" style={{ marginRight: 8 }}>
            {text === 0 ? '企' : text === 1 ? '大' : ''}
          </Avatar>
          <span style={{ fontSize: '14px', fontWeight: 'normal', color: text === 0 ? '#1890ff' : text === 1 ? '#00bcd4' : 'inherit' }}>
            {text === 0 ? '企信宝' : text === 1 ? '大经宝' : ''}
          </span>
        </span>
				) : (
					''
				)}
			</div>
		),
	},{

		title: '订单编号',
		dataIndex: 'order_no',
		key: 'order_no',
		render: (text, record) => (
			<div>
				{record.bank_res && record.is_order_sub && (
					<div style={{ marginRight: 8 , padding: '4px'}}>
						<Avatar size="small" style={{ backgroundColor: '#FFCC66' }}>补</Avatar>
					</div>
				)}
				<Tooltip placement="topLeft" title={record.bank_res ? `银行单号${record.bank_res}` : null}>
					<Tag color={record.bank_res ? '#3399CC' : (record.status === '同意' ? '#d3d3d3' : '')}>{text}</Tag>
				</Tooltip>
			</div>
		),
		width: 120,
	},
		{
			title: '贷款期限(天)',
			dataIndex: 'loan_term',
			key: 'loan_term',
			width: 90,
			render: (text) => <span style={{ color: '#00BFFF' }}>{text}</span>  // 天蓝色
		},
		{
		title: '接收时间',
		dataIndex: 'created_at',
		key: 'created_at',
		render: (text, record) => moment(record.created_at).format('YYYY-MM-DD'),
		width: 150
	}, {
		title: '订单金额',
		dataIndex: 'order_amount',
		key: 'order_amount',
		sorter: (a, b) => a.order_amount - b.order_amount,
		render: text => <span><Statistic value={text / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} /></span>,
		width: 120
	}, {
		title: '贷款金额',
		dataIndex: 'pay_amount',
		key: 'pay_amount',
		sorter: (a, b) => a.pay_amount - b.pay_amount,
		render: text => <span><Statistic value={text / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} /></span>,
		width: 120
	}, {
			title: '审批状态',
			key: 'status',
			dataIndex: 'status',
			render: (text) => {
				const statusMap = {
					'同意': { color: 'blue', label: '同意' },
					'撤销': { color: 'magenta', label: '撤销' },
					'作废': { color: 'red', label: '作废' },
					'拒绝': { color: 'red', label: '拒绝' },
				};

				const statusInfo = statusMap[text] || { color: 'green', label: '待批准' };

				return <Tag color={statusInfo.color}>{statusInfo.label}</Tag>;
			},
			width: 100
		},{
			title: '业务员',
			dataIndex: 'bizperson',
			key: 'bizperson',
			render: (text) => (
				<div>
					{text ? (
						<span>
               <Avatar size="small" style={{ marginRight: 8, backgroundColor: '#69c0ff', color: '#fff' }}>
  {text.charAt(0)}
</Avatar>
              <Statistic value={text} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} />
            </span>
					) : (
						''
					)}
				</div>
			),
			width: 80,
		}
		,
		{
			title: '支付方式',
			dataIndex: 'm_orderpay',
			key: 'pay_type',
			render: (text) => {
				const payTypeMap = {
					'01': { color: 'orange', label: '余额支付' },
					'02': { color: 'cyan', label: '授信支付' },
					'03': { color: 'black', label: '混合支付' },
				};

				const paymentInfo = text.length > 0 ? payTypeMap[text[0].pay_type] : null;

				return paymentInfo ? <Tag color={paymentInfo.color}>{paymentInfo.label}</Tag> : null;
			},
			width: 100
		},
		 {
		title: '放款金额',
		dataIndex: 'm_orderpay',
		key: 'total_pay_amount',
		render: (text) => (
			<div>
				{text.length > 0 ? <span><Statistic value={text[0].total_pay_amount / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} /></span> : null

				}
			</div>
		),
		width: 120
	}, {
		title: '支付时间',
		dataIndex: 'm_orderpay',
		key: 'pay_time',
		render: (text) => (
			<div>

				{text.length > 0 ? <span>{moment(text[0].pay_time).format('YYYY-MM-DD HH:mm')}</span> : null}
			</div>
		),
		width: 150
	}, {
			title: "用信时间",
			dataIndex: "m_orderpay",
			key: "use_credit_time",
			render: (text) => {
				// 还清的话
				if (text?.[0]?.remain_loan_amount == 0) {
					const remainDays = ((text) => {
						if (text.length > 0 && text[0].repay_date) {
							if (text[0].remain_loan_amount == 0) {
								let repayDate = new Date(text[0].repay_date);
								let payTime = new Date(text[0].pay_time);

								// Set time parts to zero to ensure date-only comparison
								repayDate.setHours(0, 0, 0, 0);
								payTime.setHours(0, 0, 0, 0);

								let resDate = Math.floor((repayDate - payTime) / (1000 * 60 * 60 * 24));
								return resDate;
							}
						}
					})(text);
					// 可能为0 天
					if (remainDays || remainDays === 0) {
						return <Tag>{remainDays}天</Tag>;
					}
				}
				if (text?.[0]?.pay_time) {
					let payTime = new Date(text[0].pay_time);

					// Set time part to zero to ensure date-only comparison
					payTime.setHours(0, 0, 0, 0);

					// 计算时间，不满一天按0天算
					const intervalTime = Math.floor((new Date().setHours(0, 0, 0, 0) - payTime) / (1000 * 60 * 60 * 24));
					return (
						<Tag>{intervalTime}天</Tag>
					);
				}
			},
			width: 100,
		},
		{
		title: '还款状态',
		dataIndex: 'm_orderpay', key: 'remain',
		render: (text, record) => {
			if (text.length > 0 && text[0].remain_loan_amount) {
				if (text[0].remain_loan_amount == 0) {
					const repayDetails = record.m_orderRepay;
					const repay_type = record.repay_type;
					let latestRepayDetail = repayDetails?.[0];
					// 取得最新一次还款记录
					repayDetails?.forEach(repayDetail => {
						if (moment(repayDetail.repay_date) > moment(latestRepayDetail.repay_date)) {
							latestRepayDetail = repayDetail;
						}
					});
					// 最新一次还款记录类型是代偿，则显示代偿结清
				/*	if (latestRepayDetail && latestRepayDetail?.repay_type == "08") {
						return <Tooltip placement="topLeft" title={moment(text[0].repay_date).format('YYYY-MM-DD') + '还款:' + text[0].repay_amount / 100}><Tag color='#C71585'>代偿未清</Tag></Tooltip>
					}*/
					if (repay_type && repay_type == "09") {
						return <Tooltip placement="topLeft" title={moment(text[0].repay_date).format('YYYY-MM-DD') + '还款:' + text[0].repay_amount / 100}><Tag color='#C71585'>代偿结清</Tag></Tooltip>
					} else if (repay_type && repay_type == "08") {
						return <Tooltip placement="topLeft" title={moment(text[0].repay_date).format('YYYY-MM-DD') + '还款:' + text[0].repay_amount / 100}><Tag color='#C71585'>代偿未清</Tag></Tooltip>
					}else {
						return <Tooltip placement="topLeft" title={moment(text[0].repay_date).format('YYYY-MM-DD') + '还款:' + text[0].repay_amount / 100}><Tag color='#2E8B57'>结清</Tag></Tooltip>

					}
				} else {
					return <Tooltip placement="topLeft" title={moment(text[0].repay_date).format('YYYY-MM-DD') + '还款:' + text[0].repay_amount / 100}><Tag color='#2E8B57'>部分还款</Tag></Tooltip>
				}
			}
			return <span></span>;
		},
		width: 100

	}, {
		title: '还款天数',
		dataIndex: 'm_orderpay', key: 'remainDays',
		render: (text) => {
			if (text.length > 0 && text[0].repay_date) {
				if (text[0].remain_loan_amount == 0) {
					let repayDate = Date.parse(text[0].repay_date);
					let payTime = Date.parse(text[0].pay_time);
					let resDate = parseInt((repayDate - payTime) / (1000 * 60 * 60 * 24))
					return <span><Tag color="pink">{resDate}天</Tag></span>;
				}
			}
			return <span></span>;
		},
		width: 100

	}, {
		title: '还款详情',
		dataIndex: 'm_orderRepay',
		key: 'orderRepayDesc',
		fixed: "right",
		render: (text, record) => {

			if (text?.length > 0) {
				return <Button onClick={() => BtnShowRepayDetail(record)}>查看</Button>
			}
			return <Tag color="silver">暂无明细</Tag>

		},
		width: 80
	}, {
		title: '未还金额(本金)',
		dataIndex: 'm_orderpay', key: 'remain_loan_amount',
		render: (text, record) => {
			if (text?.[0]?.remain_loan_amount) {
				return <span><Statistic value={text[0].remain_loan_amount / 100} precision={2} valueStyle={{ color: '#E9967A', fontSize: '15px', fontWeight: 'bold' }} /></span>
			} else if (text?.[0] && text[0].remain_loan_amount == null) {
				return <span><Statistic value={text[0].total_pay_amount / 100} precision={2} valueStyle={{ color: '#E9967A', fontSize: '15px', fontWeight: 'bold' }} /></span>
			} else if (text?.[0]?.total_pay_amount) {
				return <span><Statistic value={text[0].total_pay_amount / 100} precision={2} valueStyle={{ color: '#E9967A', fontSize: '15px', fontWeight: 'bold' }} /></span>
			}
		},
		width: 120
	},
	{
		title: '子公司',
		dataIndex: 'company',
		key: 'company',
		onFilter: (value, record) => record.company.indexOf(value) === 0,
		sorter: (a, b) => a.company.length - b.company.length,
		width: 200
	}, {
		title: '分公司',
		dataIndex: 'subcompany',
		key: 'subcompany',
		width: 200
	},  {
		title: '业务合同',
		dataIndex: 'contract_local_url',
		key: 'contract_local_url',
		fixed: "right",
		render: (text) => {
			if (text) {
				let hrefStr = server.path + text;
				return <a href={hrefStr} target='_blank'>查看</a>
			}
			return <span>未上传</span>

		},
	},{
			title: '利率',
			dataIndex: 'm_orderpay',
			key: 'loan_rate',
			render: (text) => {
				const loanRate = text.length > 0 ? text[0].loan_rate : null;

				return loanRate !== null ? (
					<Statistic value={loanRate} precision={3} valueStyle={{ fontSize: '14px', fontWeight: 'normal', color: '#1890ff' }} />
				) : (
					<Tag color="#d3d3d3">暂无</Tag>
				);
			},
			width: 120
		}, {
		title: '账龄(天)',
		dataIndex: 'm_paymentDays',
		key: 'm_paymentDays',
		render: (text, record) => text.length > 0 && text[0].payment_days ? <span><Tag color="geekblue">{text[0].payment_days}</Tag></span> : <span>无</span>,
		width: 100
	}, {
		title: '订单',
		key: 'orderDetail',
		render: (text, record) => {

			if (text) {
				return <Button onClick={() => BtnShowOrderDetail(record)}>查看</Button>
			}
			return <span>未上传</span>

		},
		width: 100
	},
	{
		title: "",
		width: 200,
	},
	];

	//定义移动界面表头
	const mobileColumns = [{
		title: '订单列表',
		dataIndex: 'm_orderclient',
		key: 'm_orderclient',
		render: (text, record) => {
			let hrefStr = server.path + record.contract_local_url;
			return (
				<span>
					<Row><Col><Tag color="#108ee9">{text.length > 0 && text[0].cust_name ? <span>{text[0].cust_name}</span> : <span>客户ID:{record.client_id}</span>}</Tag></Col>

						<Col><span>订单号:{record.order_no}{record.m_orderpay.length > 0 && <Tag color='#2E8B57'>支付成功</Tag>}</span></Col>
						<Col>接收时间:{record.created_at && moment(record.created_at).format('YYYY-MM-DD HH:mm')}</Col>
						<Col ><Statistic value={record.pay_amount / 100} precision={2} valueStyle={{ fontSize: '15px', fontWeight: 'bold' }} /></Col>
					</Row>
					<Row><Col>{record.subcompany}-{record.bizperson}</Col>
					</Row>
					{record.contract_local_url && <a href={hrefStr} target='_blank'>业务合同</a>}
					<Button size='small' onClick={() => BtnShowOrderDetail(record)}>订单详情</Button>

				</span>
			)
		}
	}];


	/**
	 * 查看工程通还款详情按钮事件
	 * @type {{selectedRowKeys, selectedRows, onSelect: rowSelection.onSelect}}
	 */
	const BtnShowRepayDetail = (record) => {
		set({ orderRepayDetailVisible: true, clickRow: record })
	}




	const rowSelection = {
		selectedRowKeys,
		selectedRows,
		onSelect: (record, selected, selectedRows, nativeEvent) => {
			if (selected) {
				set({ selectedRowKeys: [record.id], selectedRow: record, selectedRows: [record] })
			} else { set({ selectedRowKeys: [], selectedRow: {}, selectedRows: [] }) }
		},
		//onChange: (selectedRowKeys, selectedRows) => { SET({selectedRowKeys, selectedRows}) }
	};

	const BtnDelete = () => {
		return del({ id: selectedRow.id, selectedRowIndex }).then(res => {
			message.info('id:' + selectedRow.id + ' 的记录' + res)
			set({ selectedRow: {}, selectedRowIndex: -1 })
		});
	}

	const BtnHandle = async (e) => {

		if (e.target.name === 'update') {

			set({ modalVisible: true, modalType: 'update' });
		}
		if (e.target.name === 'create') {
			set({ modalVisible: true, modalType: 'create' });
		}

		if (e.target.name === 'upload') {
			set({ uploadModalVisible: true });
		}

		if (e.target.name === 'download') {  //下载全部的搜索内容，通过浏览器下载excel文件
			let hrefUrl = await getxls();
			download2(hrefUrl, '');

		}

		if (e.target.name === 'downloadAll') {
			let hrefUrl = await getxls_all();
			download2(hrefUrl, '');
		}

	}
	const cancel = (e) => {
		message.info("已取消")
	}
	const cancelOrderConfirm = () => {

		// cancelOrder(selectedRow.id);
		if (selectedRow.status == '同意') {
			set({ modalVisible: true, modalType: 'cancel' });
		} else {
			message.warning('订单不是已同意状态');
		}


		// cancelOrderToEsb(selectedRow.id);
	}


	const BtnShowOrderDetail = (record) => {
		set({ orderDetailVisible: true, clickRow: record })
	}

	pagination.onChange = (page, pageSize) => {
		if (isNaN(pageSize)) {
			//这是异常刷新，不记录任何值,比如排序刷新
			return;
		}
		let paginationNew = { ...pagination };
		paginationNew.current = page;  //如果page是1，直接提交即可			
		paginationNew.pageSize = pageSize;
		set({ pagination: paginationNew, dataLoading: true });

	}

	pagination.onShowSizeChange = (current, size) => {
		let paginationNew = { ...pagination };
		let overcount = paginationNew.pageSize * (paginationNew.current - 1);

		paginationNew.current = 1 + parseInt(overcount / size);

		paginationNew.pageSize = size;
		set({ pagination: paginationNew, dataLoading: true });

	}

	const tableDefinition = {
		rowKey: 'id',
		loading: dataLoading,
		pagination: pagination,
		size: 'small',
		columns: screenType == 'pc' ? columns : mobileColumns,
		dataSource: data,
		scroll: { x: 800, y: window.innerHeight - 370 },
		//expandedRowRender: record => <p style={{ margin: 0}}>{JSON.stringify(record.m_orderpay)}</p>,
		//rowSelection: rowSelection,
		onRow: (record, index) => { return { onClick: event => set({ selectedRow: record, selectedRowIndex: index }) } },
		rowClassName: (record, index) => index === selectedRowIndex ? 'selectedItem' : '',
	}

	const orderDetailProps = {
		item: clickRow,
		visible: orderDetailVisible,
		onOk(data) {

			set({ orderDetailVisible: false })
		},

		onCancel() {
			set({ orderDetailVisible: false })
		},
	}

	const formRenderProps = {
		onFinish(data) {
			// 1  先清空分页中原有的当前页，pagination.current =1			
			// 2 将搜索内容更新到 searchProps内。			
			// 3 更新dataLoading 为true。

			let paginationNew = { ...pagination }
			paginationNew.current = 1;

			set({ dataLoading: true, pagination: { ...paginationNew }, searchProps: data });
		}

	}


	const modalRenderProps = {

		item: modalType === 'create' ? {} : selectedRow,
		type: modalType,
		visible: modalVisible,
		onOk(data) {
			set({ modalVisible: false })
			//通知ESB转发信息给银行 并且更新状态
			cancelOrder(data).then(res => {
				if (res === "更新成功") {
					message.info(res)
				} else {
					message.error(res)
				}

			});

		},
		onCancel() {
			set({ modalVisible: false })
		},
	}

	const modaluploadProps = {

		item: selectedRow,
		visible: uploadModalVisible,
		onOk(data) {

			set({ uploadModalVisible: false })

			update(data, selectedRowIndex).then(res => message.info(res));
		},

		onReject(data) {

			set({ uploadModalVisible: false })

			update(data, selectedRowIndex).then(res => message.info(res));
		},
		onCancel() {
			set({ uploadModalVisible: false })
		},
	}


	const ModalRenderGene = () => <ModalRender {...modalRenderProps} />;
	const ModaluploadGene = () => <ModalUpload {...modaluploadProps} />;
	const ModalOrderDeatailGene = () => <OrderDetail {...orderDetailProps} />;


	/**
	 * 还款明细的属性
	 * @type {{item, visible, onCancel(): void, onOk(*): void}}
	 */
	const orderRepayDetailProps = {
		item: clickRow,
		visible: orderRepayDetailVisible,
		onOk(data) {

			set({ orderRepayDetailVisible: false })
		},

		onCancel() {
			set({ orderRepayDetailVisible: false })
		},
	}
	const ModalOrderRepayDetailGene = () => <OrderRepayDetail {...orderRepayDetailProps} />


	return (
		<div>
			<Row style={{ marginBottom: 10 }}>
				<Col span={24}><Input.Group compact size="large">
					<Button onClick={refreshData}  > <Icon type="sync" style={{ color: 'green' }} />刷新</Button>
					<Button disabled={selectedRowIndex === -1} onClick={cancelOrderConfirm} hidden={loginUserRoleAuth.indexOf('/order/list/cancelOrder') == -1}>  <Icon type="undo" /> 撤销订单</Button>
					<Divider type={"vertical"} />
					<Button type='primary' onClick={BtnHandle} name='download' hidden={loginUserRoleAuth.indexOf('/order/list/download') == -1}><Icon type="file-excel" />导出</Button>
					<Divider type={"vertical"} />
					<Tooltip placement="topLeft" title="导出企信宝，包括控货企信宝的订单明细" >
						<Button type='primary' onClick={BtnHandle} name='downloadAll' hidden={loginUserRoleAuth.indexOf('/order/list/downloadAll') == -1}><Icon type="file-excel" />导出全部</Button>
					</Tooltip>
				</Input.Group>
				</Col>

			</Row>
			<Row>
				<Col span={24}>
					<SearchRender {...formRenderProps} />
				</Col>


			</Row>
			<Table {...tableDefinition} />
			{modalVisible && <ModalRenderGene />}
			{uploadModalVisible && <ModaluploadGene />}
			{orderDetailVisible && <ModalOrderDeatailGene />}
			{orderRepayDetailVisible && <ModalOrderRepayDetailGene />}
		</div>);


}

const mapStateToProps = (state) => {
	return {
		store: state.orderRd,
		appRd: state.appReducer
	}
}

const mapDispatchToProps = (dispatch, ownProps) => {
	return {

		set: (value) => dispatch(AC.SET(value)),
		cancelOrder: (value) => dispatch(AC.CANCELORDER(value)),
		get: (value) => dispatch(AC.GET(value)),
		getxls: (value) => dispatch(AC.GETXLS(value)),
		getxls_all: (value) => dispatch(AC.GETXLSALL(value)),
		update: (value, index) => dispatch(AC.UPDATE(value, index)),
		updateremove: (index) => dispatch(AC.UPDATEREMOVE(index))
	}
}

const OrderPending = connect(mapStateToProps, mapDispatchToProps)(RenderBase);

export default OrderPending;
